import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconActiveProps, IconRender } from '../types.ts';

const EnlargeCollapse = React.forwardRef<SVGSVGElement | null, IconActiveProps>(function EnlargeCollapse(
  { active, dataTestId, ...props },
  ref,
) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.75 3.25C21.0261 3.25 21.25 3.47386 21.25 3.75V9.5C21.25 9.77614 21.0261 10 20.75 10H20.25C19.9738 10 19.75 9.77614 19.75 9.5V5.81066L14.3839 11.1768C14.1886 11.372 13.872 11.372 13.6768 11.1768L13.3232 10.8232C13.1279 10.628 13.1279 10.3114 13.3232 10.1161L18.6893 4.75H15C14.7238 4.75 14.5 4.52614 14.5 4.25V3.75C14.5 3.47386 14.7238 3.25 15 3.25H20.75ZM4.25 20.75C3.97386 20.75 3.75 20.5262 3.75 20.25V14.5C3.75 14.2239 3.97386 14 4.25 14H4.75C5.02614 14 5.25 14.2239 5.25 14.5V18.1894L10.6161 12.8232C10.8114 12.628 11.128 12.628 11.3232 12.8232L11.6768 13.1768C11.872 13.3721 11.872 13.6886 11.6768 13.8839L6.31066 19.25H10C10.2761 19.25 10.5 19.4739 10.5 19.75V20.25C10.5 20.5262 10.2761 20.75 10 20.75H4.25Z'
          fill={active ? 'transparent' : color}
        />
        {/* active */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.25 10.75C13.9739 10.75 13.75 10.5262 13.75 10.25L13.75 4.50001C13.75 4.22387 13.9739 4.00001 14.25 4.00001L14.75 4.00001C15.0261 4.00001 15.25 4.22387 15.25 4.50001L15.25 8.18935L20.6161 2.82324C20.8114 2.62797 21.128 2.62797 21.3232 2.82323L21.6768 3.17679C21.872 3.37205 21.872 3.68863 21.6768 3.8839L16.3107 9.25001L20 9.25001C20.2761 9.25001 20.5 9.47387 20.5 9.75001V10.25C20.5 10.5262 20.2761 10.75 20 10.75L14.25 10.75ZM10.75 13.25C11.0261 13.25 11.25 13.4739 11.25 13.75V19.5C11.25 19.7761 11.0261 20 10.75 20H10.25C9.97384 20 9.74998 19.7761 9.74998 19.5L9.74998 15.8107L4.38387 21.1768C4.1886 21.372 3.87202 21.372 3.67676 21.1768L3.3232 20.8232C3.12794 20.628 3.12794 20.3114 3.3232 20.1161L8.68932 14.75H4.99998C4.72384 14.75 4.49998 14.5261 4.49998 14.25V13.75C4.49998 13.4739 4.72384 13.25 4.99998 13.25L10.75 13.25Z'
          fill={active ? color : 'transparent'}
        />
      </>
    ),
    [active],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'enlarge-collapse-icon-svg'} iconRender={iconRender} {...props} />;
});

export default EnlargeCollapse;
